import { EditState } from './';
import { ISurveyQuestionEditModel } from './ISurveyQuestionEditModel';

export interface IQuestionChange {
	surveyQuestionId?: number;
	question: ISurveyQuestionEditModel;
	changes: IQuestionChangeDetail[];
}

export interface IQuestionChangeDetail {
	cultureCode: string;
	cultureName: string;
	text: string;
	changeType: QuestionChangeType;
	editState: EditState;
}

export enum QuestionChangeType {
	Question = 1,
	QuestionTranslation = 2,
	ResponseOptionGroup = 3,
	ResponseOption = 4,
	ResponseOptionTranslation = 5,
}
